<template>
  <div class="not-wrap">
    <div class="logo"></div>
    <h6>呼呼打药</h6>
    <p class="p1">体验非农户身份功能</p>
    <p class="p2">请下载呼呼打药APP</p>
    <DownApp></DownApp>
  </div>
</template>
<script>
import DownApp from '../../components/downApp/downApp';

export default {
  name: 'notFarmer',
  components: { DownApp },
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {},
  destroyed() {},
  methods: {},
};
</script>
<style lang="stylus" scoped>
.not-wrap
  padding-top 80px
  .logo
    width 70px
    height 70px
    background url('./logo.png') no-repeat
    background-size 100%
    margin 0 auto
  h6
    font-size 18px
    font-weight bold
    color rgba(51, 51, 51, 1)
    margin-top 10px
  .p1
    font-size 15px
    color rgba(153, 153, 153, 1)
    line-height 1.2
    margin-top 24px
  .p2
    font-size 15px
    color rgba(153, 153, 153, 1)
    line-height 1.2
    margin-top 5px
</style>
